import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18 3c.552.001.999.448 1 1v10c-.001.552-.448.999-1 1H9l-.267.2L5 17.994V15H2a1.0016 1.0016 0 0 1-1-1V4c.001-.552.448-.999 1-1h16zm0-1H2c-1.103.003-1.997.897-2 2v10c.003 1.103.897 1.997 2 2h2V17.995c0 .554.449 1.004 1.004 1.004h.003c.226 0 .434-.076.6-.204L9.333 16H18c1.103-.003 1.997-.897 2-2V4c-.003-1.103-.897-1.997-2-2z',
  ],
  height: 20,
  width: 20,
});
